import React, { useState } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import { useLocation } from '@gatsbyjs/reach-router';
import Wrapper from './wrapper';
import ButtonErrorWrapper from './button-error-wrapper';
import StyledForm from './form-component';
import Button from './button';
import Title from './title';
import Field from './field';
import Intro from './intro';
import ErrorAlert from './alert/error';
import SuccessAlert from './alert/success';
import useCreateSubmission from '../hooks/use-create-submission';

// Use this fragment in your pageQuery
// and use it as <Form {...page.form} />
export const query = graphql`
  fragment StrapiForm on STRAPI_FormsForm {
    id
    name
    title
    intro
    buttonText
    fields {
      typename: __typename
      ...on STRAPI_ComponentFormsInput {
         ...StrapiFormInput
      }
      ...on STRAPI_ComponentFormsSelect {
        ...StrapiFormSelect
      }
    }
  }
`;

const Form = ({
  id,
  name,
  title,
  intro,
  buttonText,
  fields,
  removeFormWhenSuccess = true,
  className,
  ...props
}) => {
  // allow setting values via a Link
  const { state } = useLocation();
  // remove the key that gatsby always adds
  const { key: _, via: __, ...locationState } = state || {};
  // get all defaultValues ready
  const initialFormFields = fields.reduce((result, field) => ({
    ...result,
    [field.name]: (field.typename === 'STRAPI_ComponentFormsSelect' ? field.values[0].value : ''), // maybe add a feature to set defaultValue?
  }), {});
  // the initial form state is defaultValues and what is pushed in the location state
  const [formValues, setValues] = useState({
    ...initialFormFields,
    ...locationState,
  });

  const {
    onSubmit,
    data,
    loading,
    error,
  } = useCreateSubmission(formValues, name, id);

  const showForm = !removeFormWhenSuccess || !(removeFormWhenSuccess && data);

  return (
    <Wrapper className={className} name={name}>
      {title && <Title>{title}</Title>}
      {intro && <Intro $content={intro} />}
      {showForm && (
        <StyledForm
          {...props}
          onSubmit={onSubmit}
        >
          <input type="hidden" name="form-name" value={name} />
          {fields.map((field) => (
            <Field
              key={field.id}
              {...field}
              onChange={(e) => {
                setValues({
                  ...formValues,
                  [field.name]: e.target.value,
                });
              }}
              value={formValues[field.name]}
            />
          ))}
          <ButtonErrorWrapper>
            {data && (
              <SuccessAlert data={data} />
            )}
            {error && (
              <ErrorAlert error={error} />
            )}
            <Button
              type="submit"
              disabled={loading}
            >
              {buttonText}
            </Button>
          </ButtonErrorWrapper>
        </StyledForm>
      )}
      {data && !showForm && (
        <SuccessAlert data={data} />
      )}
    </Wrapper>
  );
};

export default styled(Form)``;
